import LinearProgress from "@mui/material/LinearProgress";
import FormModal from "../FormModal/FormModal";
import Buttons from "../Buttons/Buttons";

const DownloadOptionsModal = ({
  row,
  onDownloadCsv,
  onDownloadProcessedCsv,
  onCancel,
  isDownloadingCsv = false,
  isDownloadingProcessedCsv = false,
  downloadProgress = null,
}) => {
  const isBusy = isDownloadingCsv || isDownloadingProcessedCsv;
  // A processed CSV always ships with a log file except when it was
  // processed before logs were generated for it — that's the only case
  // that downloads as a lone CSV instead of a bundled ZIP.
  const processedIsZip = !(row?.processedCSVUrl && !row?.logFileUrl);
  const zippingLabel =
    typeof downloadProgress === "number" ? `Zipping files... ${downloadProgress}%` : "Zipping files...";

  return (
    <FormModal
      open
      onClose={onCancel}
      title="Download CSV"
      actions={
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
          <Buttons
            text={isDownloadingCsv ? "Downloading..." : "Download CSV"}
            type="button"
            variant="primary"
            onClick={onDownloadCsv}
            disabled={!row.csvUrl || isBusy}
            loading={isDownloadingCsv}
          />
          <Buttons
            text={
              isDownloadingProcessedCsv
                ? processedIsZip
                  ? zippingLabel
                  : "Downloading..."
                : processedIsZip
                  ? "Download Processed CSV + Log (ZIP)"
                  : "Download Processed CSV"
            }
            type="button"
            variant="primary"
            onClick={onDownloadProcessedCsv}
            disabled={!row || isBusy}
            loading={isDownloadingProcessedCsv}
          />
          {isDownloadingProcessedCsv && processedIsZip && typeof downloadProgress === "number" && (
            <LinearProgress variant="determinate" value={downloadProgress} />
          )}
          <Buttons text="Cancel" type="button" variant="secondary" onClick={onCancel} disabled={isBusy} />
        </div>
      }
    >
      <p style={{ textAlign: "center", margin: 0 }}>Do you want to download the CSV file?</p>
      {processedIsZip && (
        <p style={{ textAlign: "center", margin: "8px 0 0", fontSize: "12px", color: "#6b6a6a" }}>
          The processed CSV and log file are bundled together into one ZIP.
        </p>
      )}
    </FormModal>
  );
};

export default DownloadOptionsModal;
